import ErrorMessage from 'framework-asset-preview-lib/internal/shared/components/ErrorMessage';
import LoadingOverlay from 'framework-asset-preview-lib/internal/shared/components/LoadingOverlay';
import useFetchAssetPerformance from '../hooks/useFetchAssetPerformance';
import PerformanceGroupSection from './PerformanceGroupSection';
import { jsx as _jsx } from "react/jsx-runtime";
export default function PerformanceSection({
  crmObject,
  nonCrmObject,
  properties,
  propertyGroups
}) {
  const {
    data,
    error,
    loading
  } = useFetchAssetPerformance(crmObject, nonCrmObject);
  if (loading) {
    return /*#__PURE__*/_jsx(LoadingOverlay, {
      previewType: "sidepanel"
    });
  }
  if (error || !data) {
    return /*#__PURE__*/_jsx(ErrorMessage, {
      errorType: "PERFORMANCE_TAB",
      objectId: crmObject.objectId,
      objectType: crmObject.objectTypeId
    });
  }
  return /*#__PURE__*/_jsx("section", {
    children: data.map((performanceGroup, index) => /*#__PURE__*/_jsx(PerformanceGroupSection, {
      crmObject: crmObject,
      nonCrmObject: nonCrmObject,
      performanceGroup: performanceGroup,
      properties: properties,
      propertyGroups: propertyGroups
    }, index))
  });
}